import React, { useMemo } from "react";

import { Box } from "@chakra-ui/react";
import { useMediaQuery } from "hooks/useMediaQuery";

import { Heading4 } from "ui/typography";

import { IBusinessContentItemProps } from "./types";

export const BusinessContentItem = (props: IBusinessContentItemProps) => {
  const {
    title,
    content,
    isContentWrapperBelow745,
    isContentWrapperBelow600,
    businessContentItemClassName,
    busienssContentItemHeaderClassName,
  } = props;
  const isLgScreen = useMediaQuery("(min-width: 1650px)");

  const businessContentItemWrapperClassName = useMemo(() => {
    let classNames = "flex flex-col gap-1 h-fit";
    if (isContentWrapperBelow600) {
      classNames += " basis-[100%]";
    } else if (isContentWrapperBelow745) {
      classNames += " basis-[45%] w-full max-w-[322.2px]";
    } else {
      classNames += ` ${businessContentItemClassName || "basis-[30%] w-full"} ${isLgScreen ? "max-w-[30%]" : ""}`;
    }

    return classNames;
  }, [isContentWrapperBelow745, isContentWrapperBelow600, isLgScreen]);

  if (!title && !content) return <></>;

  return (
    <Box className={businessContentItemWrapperClassName}>
      <Heading4
        textColor="#718096"
        lineHeight="22.4px"
        className={`h-[22px] ${busienssContentItemHeaderClassName || ""}`}
        fontSize="14px"
      >
        {title}
      </Heading4>
      <Box
        css={{
          minHeight: "24px",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "24px",
          color: "#101828",
          textTransform: "capitalize",
        }}
      >
        {content}
      </Box>
    </Box>
  );
};
